export default __webpack_public_path__ + "c11.png";